var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('div',{staticClass:"loading-page",style:({opacity: _vm.op})}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }